import { createAction, props } from '@ngrx/store';
import { Order } from './models/Order';
import { OrderSource } from './models/OrderSource';
import { Dayjs } from 'dayjs';


// Load Orders
export const loadOrders = createAction('[Orders] Load Orders');

export const loadOrder = createAction('[Orders] Load Order');

export const loadOrdersSuccess = createAction(
  '[Orders] Load Orders Success',
  props<{ orders: Order[] }>()
);

export const loadOrdersFailure = createAction(
  '[Orders] Load Orders Failure',
  props<{ error: string }>()
);

// Create Order
export const createOrder = createAction(
  '[Orders] Create Order',
  props<{ order: Order }>()
);

export const createOrderSuccess = createAction(
  '[Orders] Create Order Success',
  props<{ order: Order }>()
);

export const createOrderFailure = createAction(
  '[Orders] Create Order Failure',
  props<{ error: string }>()
);

// Update Order
export const updateOrder = createAction(
  '[Orders] Update Order',
  props<{ order: Order, orderId: number }>()
);

export const updateOrderSuccess = createAction(
  '[Orders] Update Order Success',
  props<{ order: Order }>()
);

export const updateOrderFailure = createAction(
  '[Orders] Update Order Failure',
  props<{ error: string }>()
);

// Delete Order
export const deleteOrder = createAction(
  '[Orders] Delete Order',
  props<{ orderId: string }>()
);

export const deleteOrderSuccess = createAction(
  '[Orders] Delete Order Success',
  props<{ orderId: string }>()
);

export const deleteOrderFailure = createAction(
  '[Orders] Delete Order Failure',
  props<{ error: string }>()
);

export const loadOrderSourcesList = createAction(
  '[Orders] Load Order Sources List',
  props<{
    from: Date | null, to: Date | null, column: 'Created Date' | 'Delivery Date' | 'Completed Date' | null
  }>()
);

export const loadOrderSourcesListSuccess = createAction(
  '[Orders] Load Order Sources List Success',
  props<{ orderSources: OrderSource[] }>()
);

export const setOrderToComplete = createAction(
  '[Orders] Set Order To Complete',
  props<{
    orderId: number,
    completedDate: string,
    receivedBy: string,
    podAttachments: File[]
  }>()
);
